import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";

const USEFUL_LINKS = ["FAQs", "Help & Support", "Terms of Service", "Cancellation & Refunds"];
const QUICK_LINKS = ["Track Order", "Privacy Policy", "Shipping Rates", "Locate Service Centres"];
const SOCIALS = [
  { Icon: FaFacebookF, label: "Facebook" },
  { Icon: FaInstagram, label: "Instagram" },
  { Icon: FaTwitter, label: "Twitter" },
];

export default function Footer() {
  return (
    <footer className="bg-surface border-t border-border pt-16">
      <div className="container mx-auto">
        {/* brand */}
        <div className="flex items-center gap-x-6 mb-14">
          <span className="h-px flex-1 bg-border" />
          <Link to="/" className="font-display text-2xl font-semibold tracking-wide text-ink">
            Camera<span className="text-brand"> Haus</span>
          </Link>
          <span className="h-px flex-1 bg-border" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* useful links */}
          <nav className="text-center md:text-left">
            <h3 className="uppercase tracking-[0.15em] text-sm font-semibold mb-6">
              Useful Links
            </h3>
            <ul className="flex flex-col gap-y-4 text-muted">
              {USEFUL_LINKS.map((label) => (
                <li key={label}>
                  <a
                    href=""
                    className="hover:text-brand transition-colors">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* connect */}
          <div className="flex flex-col items-center gap-y-6">
            <div className="flex gap-x-4">
              {SOCIALS.map(({ Icon, label }) => (
                <a
                  key={label}
                  href=""
                  aria-label={label}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-canvas text-muted border border-border hover:bg-brand hover:text-white hover:border-brand transition-all">
                  <Icon />
                </a>
              ))}
            </div>
            <h3 className="uppercase tracking-[0.15em] text-sm font-semibold">
              Connect With Us
            </h3>
            <form className="w-full max-w-xs flex flex-col gap-y-3">
              <label htmlFor="footer-email" className="sr-only">
                Email address
              </label>
              <input
                id="footer-email"
                type="email"
                placeholder="Your Email*"
                className="input h-12 px-4"
              />
              <button type="submit" className="btn btn-accent h-12">
                Subscribe
              </button>
            </form>
          </div>

          {/* quick links */}
          <nav className="text-center md:text-right">
            <h3 className="uppercase tracking-[0.15em] text-sm font-semibold mb-6">
              Quick Links
            </h3>
            <ul className="flex flex-col gap-y-4 text-muted">
              {QUICK_LINKS.map((label) => (
                <li key={label}>
                  <a
                    href=""
                    className="hover:text-brand transition-colors">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <div className="py-8 border-t border-border">
        <div className="container mx-auto text-center text-sm text-muted">
          &copy; 2026 Camera Haus. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
